import React, { useState } from 'react'
import { Element, ElementTitle } from '../styled';
import FromInput from '../../../../../components/inputs/FromInput';
import { useForm, useFetch } from '../../../../../hooks';
import FromSelect from '../../../../../components/inputs/FromSelect';
// import FromRadio from '../../../../../components/inputs/FromRadio';
import Buttons from '../../../../../modules/Buttons';
import Button from '../../../../../components/inputs/Button';
import { CardItem, CardHeader } from '../../../../../components/Card';
import Divider from '../../../../../components/Divider';
import CardSection from '../../../../../components/Card/CardSection';
import { prop, pathOr } from 'ramda';

const Settings = ({ data, refetchAccount }) => {

    const { doFetch } = useFetch({
        url: `/rpc/setsettings`,
        method: 'POST'
    })

    const [isEditMode, setEditMode] = useState(false);

    const validate = values => {
        const errors = {}

        if (!Number.isInteger(Number(values.herd))) {
            errors.herd = "Wprowadź liczbę całkowitą"
        }
        if (!Number.isInteger(Number(values['milking_number']))) {
            errors['milking_number'] = "Wprowadź liczbę całkowitą"
        }
        if (!Number.isInteger(Number(values['drying_period']))) {
            errors['drying_period'] = "Wprowadź liczbę całkowitą"
        }

        return errors;
    }

    const save = values => {
        doFetch({
            data: values
        }).then(res => {
            if (res === 1) {
                setEditMode(false);
                refetchAccount()
            } else {
                throw Error(res);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: save,
        validate: validate,
        initValues: {
            herd: data.herd.value || 0,
            maintain_system: data['maintain_system'].value || 0,
            summer_access: data['summer_access'].value || 0,
            feeding_system: data['feeding_system'].value || 0,
            litter_system: data['litter_system'].value || 0,
            milking_type: data['milking_type'].value || 0,
            milking_number: data['milking_number'].value || 0,
            milker_producer: data['milker_producer'].value || '',
            drying_period: data['drying_period'].value || 0
        }
    })

    return (
        <CardSection>
            <CardHeader>{data.title}</CardHeader>
            <Divider />
            {
                isEditMode ?
                    (
                        <form onSubmit={handleSubmit}>
                            <Element>
                                <ElementTitle>{data.herd.title}</ElementTitle>
                                <FromInput
                                    type='number'
                                    placeholder={data.herd.placeholder}
                                    name='herd'
                                    onChange={handleChange}
                                    value={values.herd.toString()}
                                    error={errors.herd}
                                />
                            </Element>
                            <Element>
                                <ElementTitle>{data['maintain_system'].title}</ElementTitle>
                                <FromSelect
                                    placeholder={data['maintain_system'].placeholder}
                                    name='maintain_system'
                                    onChange={handleChange}
                                    value={values['maintain_system'].toString()}
                                    error={errors['maintain_system']}
                                    options={data['maintain_system'].options}
                                    noMargin
                                />
                            </Element>
                            {/* <Element>
                                <ElementTitle>{data['summer_access'].title}</ElementTitle>
                                <FromRadio
                                    name='summer_access'
                                    onChange={handleChange}
                                    value={values['summer_access'] === "true" ? true : false}
                                    options={data['summer_access'].options}
                                />
                            </Element> */}
                            {/* <Element>
                                <ElementTitle>{data['feeding_system'].title}</ElementTitle>
                                <FromSelect
                                    name='feeding_system'
                                    placeholder={data['feeding_system'].placeholder}
                                    onChange={handleChange}
                                    value={values['feeding_system'].toString()}
                                    error={errors['feeding_system']}
                                    options={data['feeding_system'].options}
                                    noMargin
                                />
                            </Element> */}
                            {/* <Element>
                                <ElementTitle>{data['litter_system'].title}</ElementTitle>
                                <FromSelect
                                    name='litter_system'
                                    placeholder={data['litter_system'].placeholder}
                                    onChange={handleChange}
                                    value={values['litter_system'].toString()}
                                    error={errors['litter_system']}
                                    options={data['litter_system'].options}
                                    noMargin
                                />
                            </Element> */}
                            {/* <Element>
                                <ElementTitle>{data['milking_type'].title}</ElementTitle>
                                <FromSelect
                                    name='milking_type'
                                    placeholder={data['milking_type'].placeholder}
                                    onChange={handleChange}
                                    value={values['milking_type'].toString()}
                                    error={errors['milking_type']}
                                    options={data['milking_type'].options}
                                    noMargin
                                />
                            </Element> */}
                            {/* <Element>
                                <ElementTitle>{data['milking_number'].title}</ElementTitle>
                                <FromInput
                                    type='number'
                                    placeholder={data['milking_number'].placeholder}
                                    name='milking_number'
                                    onChange={handleChange}
                                    value={values['milking_number'].toString()}
                                    error={errors['milking_number']}
                                />
                            </Element> */}
                            {/* <Element>
                                <ElementTitle>{data['milker_producer'].title}</ElementTitle>
                                <FromInput
                                    type='text'
                                    placeholder={data['milker_producer'].placeholder}
                                    name='milker_producer'
                                    onChange={handleChange}
                                    value={values['milker_producer'].toString()}
                                    error={errors['milker_producer']}
                                />
                            </Element> */}
                            <Element>
                                <ElementTitle>{data['drying_period'].title}</ElementTitle>
                                <FromInput
                                    type='number'
                                    placeholder={data['drying_period'].placeholder}
                                    name='drying_period'
                                    onChange={handleChange}
                                    value={values['drying_period'].toString()}
                                    error={errors['drying_period']}
                                />
                            </Element>
                            <Buttons stretch>
                                <Button
                                    type="button"
                                    width="48%"
                                    onClick={() => setEditMode(false)}
                                >
                                    {data.buttons.cancel}
                                </Button>
                                <Button type="submit" green width="48%">
                                    {data.buttons.save}
                                </Button>
                            </Buttons>
                        </form>
                    )
                    :
                    (
                        <>
                            <CardItem
                                left={{
                                    name: data['herd'].title,
                                    value: data['herd'].value
                                }}
                            />
                            <Divider />
                            <CardItem
                                left={{
                                    name: data['maintain_system'].title,
                                    value: data['maintain_system'].value ? data['maintain_system'].options.find(option => option.value === data['maintain_system'].value).label : ''
                                }}
                            />
                            <Divider />
                            {/* <CardItem
                                left={{
                                    name: data['summer_access'].title,
                                    value: (() => {
                                        if (data['summer_access'].value !== null) {
                                            return data['summer_access'].options.find(option => option.value === data['summer_access'].value).label;
                                        } else {
                                            return data['summer_access'].options.find(option => option.value === false).label;
                                        }
                                    })()
                                }}
                            />
                            <Divider /> */}
                            {/* <CardItem
                                left={{
                                    name: data['feeding_system'].title,
                                    value: data['feeding_system'].value ? data['feeding_system'].options.find(option => option.value === data['feeding_system'].value).label : ''
                                }}
                            />
                            <Divider /> */}
                            {/* <CardItem
                                left={{
                                    name: data['litter_system'].title,
                                    value: data['litter_system'].value ? data['litter_system'].options.find(option => option.value === data['litter_system'].value).label : ''
                                }}
                            />
                            <Divider /> */}
                            {/* <CardItem
                                left={{
                                    name: data['milking_type'].title,
                                    value: data['milking_type'].value ? data['milking_type'].options.find(option => option.value === data['milking_type'].value).label : ''
                                }}
                            />
                            <Divider /> */}
                            {/* <CardItem
                                left={{
                                    name: data['milking_number'].title,
                                    value: data['milking_number'].value
                                }}
                            />
                            <Divider /> */}
                            {/* <CardItem
                                left={{
                                    name: data['milker_producer'].title,
                                    value: data['milker_producer'].value
                                }}
                            />
                            <Divider /> */}
                            <CardItem
                                left={{
                                    name: data['drying_period'].title,
                                    value: data['drying_period'].value
                                }}
                            />
                            {
                               prop('integration', data) &&
                                <>
                                    <Divider />
                                    <CardItem
                                        left={{
                                            name: pathOr('', ['integration', 'title'], data),
                                            value: pathOr('', ['integration', 'data'], data)
                                        }}
                                    />
                                </>
                            }
                            <Button
                                type="submit"
                                green
                                fullWidth
                                onClick={() => setEditMode(true)}
                            >
                                {data.buttons.edit}
                            </Button>
                        </>
                    )
            }
        </CardSection>
    )
}

export default Settings
